import { serviceRequest } from 'utils/http';
import { ReferralService } from 'common/api';

export function getReferralProtocolAPI(referralId: string) {
  return serviceRequest(() =>
    ReferralService.referralControllerGetCurrentUserProtocol(referralId)
  );
}
